
import initMenu from './modules/menu';
import './modules/interactiveTool';
import initFavorites from './modules/favorites';
import initShare from './modules/share';
import initSlider from './modules/slider';
import initPersonaChooser from './modules/personaChooser';
import initSectionToggler from './modules/sectionToggler';
import initCompassPageSectionToggle from './modules/compassPageSectionToggler';
import initToolChooser from './modules/toolChooser';
import './modules/explainerAccordion';
import initNetworkIntakeForm from './modules/networkIntakeForm';
import initTooltips from './modules/tooltips';

// Wait for the DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
    // console.log( "CareerReady :: DOMContentLoaded" );
    gsap.registerPlugin(ScrollTrigger);
    initMenu();  
    initFavorites();
    initShare();
    initSlider();
    initPersonaChooser();
    initToolChooser();
    initTooltips();
    
    const mapsBlock = document.querySelector('.compass-maps');
    const mapsTogglerBlock = document.querySelector('.compass-maps-toggle ');
    if ( mapsTogglerBlock && mapsBlock ) {
        initCompassPageSectionToggle( mapsTogglerBlock , mapsBlock );
    }

    initSectionToggler();
    initNetworkIntakeForm();
}); 
